module.exports = __webpack_public_path__ + "img/analyse-mobile.42ea994.svg";